import React, { useState } from "react"
import { navigate } from "gatsby"
export const myContext = React.createContext()

const Provider = props => {
  const [currentLanguage, setCurrentLanguage] = useState("en")
  const [translatedSlug, setTranslatedSlug] = useState("")

  return (
    <myContext.Provider
      value={{
        currentLanguage,
        setCurrentLanguage,
        switchLanguage: () => {
          const newLanguage = currentLanguage === "fr" ? "en" : "fr"
          setTimeout(() => {
            setCurrentLanguage(newLanguage)
          }, 300)

          navigate(`/${newLanguage}/${translatedSlug}`)
        },
        translatedSlug,
        setTranslatedSlug,
      }}
    >
      {props.children}
    </myContext.Provider>
  )
}

export default ({ element }) => <Provider>{element}</Provider>
